import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showTimeConflictsError } from '../../../actions/court-scheduler-actions';
import Popup from '../../Popup';

import styles from './matchTimeConflictsPopup.scss';

const MatchTimeConflictsPopup = () => {
    const dispatch = useDispatch();
    const courtScheduler = useSelector(({ courtScheduler }) => courtScheduler);

    const onCloseClick = () => {
        dispatch(showTimeConflictsError(false));
    };

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.matchTimeConflictsPopup}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <h6 className={styles.title} data-testid="modal.match-time-conflicts.title">
                {courtScheduler.timeConflictsTitle}
            </h6>
            <p className={styles.description} data-testid="modal.match-time-conflicts.message">
                {courtScheduler.timeConflictsMessage}
            </p>
            <button
                className={`btn btn-default ${styles.button}`}
                type="button"
                onClick={onCloseClick}
                data-testid="modal.match-time-conflicts.ok-btn"
            >
                OK
            </button>
        </Popup>
    );
};

export default MatchTimeConflictsPopup;
